// extracted by mini-css-extract-plugin
module.exports = {"ball":"LoadingSpinner_ball__2mU0Z","bounce":"LoadingSpinner_bounce__362Ef"};